import React, { useState, useEffect } from "react";
import Sidebar from "../src/Components/Sidebar";
import Layout from "./layout/Layout";
import "./index.css";
import ServiceComboTable from "./Components/AdminServiceComponent/ServiceComboTable";
import { useQuery, gql } from "@apollo/client";
import Loader from "./Loader";

const SERVICE_COMBOS_LIST = gql`
  query {
    getServiceCombos {
      id
      name
      isActive
      priority
      services {
        id
        name
      }
      inventoryList {
        id
        price
        alternateGroupId
        comboInventoryCategory {
          id
          name
        }
      }
    }
  }
`;

const AdminServiceCombo = () => {
  const { loading, data } = useQuery(SERVICE_COMBOS_LIST);
  const [comboList, setComboList] = useState([]);
  const [isFetched, setIsFetched] = useState(false);

  useEffect(() => {
    try {
      setComboList(data.getServiceCombos || []);
      setIsFetched(true);
    } catch (err) {
      console.log(err);
    }
  }, [data]);

  if (loading || !isFetched) return <Loader />;

  return (
    <div className="min-h-screen flex">
      <Sidebar />
      <Layout>
        <ServiceComboTable combos={comboList} />
      </Layout>
    </div>
  );
};

export default AdminServiceCombo;
